import { AbstractControl, FormGroup, Validators } from '@angular/forms';
import { Tag } from '@qaroni-app/tags/types/tag';
import {
  TagColorArray,
  TagColorEnum,
} from '@qaroni-app/tags/types/tag-color.enum';
import { QaroniBaseFormsDirective } from '@qaroni-core/directives/qaroni-base-forms/qaroni-base-forms.directive';

export class TagsMenuUpdateDialogForm extends QaroniBaseFormsDirective {
  private skeleton = {
    name: this.fb.control(null, { validators: Validators.required }),
    color: this.fb.control(null, {
      validators: [Validators.pattern(/[0-9a-fA-F]+/), Validators.minLength(6)],
    }),
  };

  public form: FormGroup = this.fb.group(this.skeleton);

  get TagColorArray(): TagColorEnum[] {
    return TagColorArray;
  }

  get name(): AbstractControl {
    return this.form.get('name');
  }

  get color(): AbstractControl {
    return this.form.get('color');
  }

  get dirtyValidForm(): boolean {
    return this.form.dirty && this.form.valid;
  }

  public populateUpdateTagForm(tag: Tag): void {
    if (tag?.tagId) {
      this.form.patchValue(tag);
    }
  }
}
